/* tslint:disable */
/* eslint-disable */
/**
 * zbo-connector API
 * zbo-connector - client
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
*
* @export
* @enum {string}
*/
export var EnumZboTypKontaktniOsoby;
(function (EnumZboTypKontaktniOsoby) {
    EnumZboTypKontaktniOsoby["PODEPISUJICI"] = "PODEPISUJICI";
    EnumZboTypKontaktniOsoby["VECNA_SPRAVNOST"] = "VECNA_SPRAVNOST";
})(EnumZboTypKontaktniOsoby || (EnumZboTypKontaktniOsoby = {}));
//# sourceMappingURL=enum-zbo-typ-kontaktni-osoby.js.map